exports = module.exports = require("../../../../../develop/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-input[data-v-1062a6bc] input{width:110px}.select-box[data-v-1062a6bc]{max-width:110px}.info-table[data-v-1062a6bc]{font-size:18px}.info-label[data-v-1062a6bc]{vertical-align:text-top;font-size:10px}.info-sum[data-v-1062a6bc]{font-size:18px;text-align:right}.info-sell[data-v-1062a6bc]{color:red}.info-buy[data-v-1062a6bc]{color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/css-loader?minimize!/Users/gtirby/develop/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1062a6bc","scoped":true,"hasInlineConfig":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = 367
// module chunks = 0